import { call, put, takeEvery } from 'redux-saga/effects';
import { LOAD_ALL_FONTS, loadAllFontsSuccess } from 'JS/actionCreators/fontActions';
import { loadAllSelectableFonts } from 'JS/shared/helpers/preloadScribeFonts';

export function* loadAllFontsSaga({ scribe }) {
  const currentScribeText = scribe.elements
    .filter(el => el.type === 'Text')
    .reduce((prev, el) => {
      return prev + el.text;
    }, '');

  yield call(loadAllSelectableFonts, currentScribeText);
  yield put(loadAllFontsSuccess());
}

function* fontSagas() {
  yield takeEvery(LOAD_ALL_FONTS, loadAllFontsSaga);
}

export default fontSagas;
